// extracted by mini-css-extract-plugin
export var carrierIcon = "_w9-0";
export var carrierLogo = "_w9-1";
export var detailsSection = "_w9-2";